import { ReactNode } from 'react'

import { Navigate } from 'react-router-dom'

interface Props {
  enabled: boolean
  children: ReactNode
}

export const RouteAccess = ({ enabled, children }: Props) => {
  if (!enabled) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  return <>{children}</>
}
